import Time from 'model/appointments/timeSlots/time'
import { isNil } from 'ramda'
import { SUGGESTED } from 'constants/appointments'

class Suggested extends Time {
  constructor(init) {
    super(init)
    // console.log('> Suggested constructor -', init)
    if (isNil(init)) return undefined
    this.__typename = init.__typename
  }

  get display_kind() {
    return this._display_kind || 'Suggested Time'
  }

  // Calculable
  get isSuggested() {
    return (this.__typename || SUGGESTED) === SUGGESTED
  }
}

export default Suggested
